import React from 'react'
import styled from 'styled-components'
import LabshighBG from '../../../../assets/bg/mobile/bg_labshigh.png'

const LabshighMobileComponent: React.FC<any> = () => {
  return (
    <Wrap>
      <img src={LabshighBG} />
    </Wrap>
  )
}

export default LabshighMobileComponent

const Wrap = styled.div``
